export enum SchedulersViewTab {
    ALL_SCHEDULERS = 'run-history',
    RUN_HISTORY = 'scheduled-deliveries',
}
